import React, { Component } from "react";

import { Link } from "react-router-dom";

import SharingInviteView from "../../share/sharing_invite_view";
import YAYImg from "../../../design/img/yay.png";

class ListFinished extends Component {
  state = {};
  render() {
    if (this.props.invite_giveaway) {
      return this.renderInviteGiveaway();
    }
    return (
      <div className="page_top_nav profilePage list center">
        <div
          style={
            {
              // top: "50%",
              // left: "50%",
              // transform: "translate(-50%, -50%)",
              // position: "absolute",
              // width: "100%"
            }
          }
        >
          <div className="pt-5">
            <img
              src={YAYImg}
              alt=""
              style={{ width: "55%", maxWidth: "500px" }}
            />
            <div
              style={{
                width: "80%",
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: "20px",
                maxWidth: "500px"
              }}
            >
              {this.renderThanks()}
            </div>
          </div>
        </div>
        <div className="fixed-bottom pb-3">
          <div>
            <div
              className="btn_skip"
              style={{
                color: "#ff5116",
                textTransform: "uppercase",
                fontFamily: "DIN Pro Bold"
              }}
            >
              Invite Friends For Additional Entries
            </div>
            <button
              className="btn btn_primary btn_yaystack  btn_next "
              style={{
                width: "66px",
                borderRadius: "33px",
                fontSize: "40px",
                padding: "10px",
                lineHeight: "1"
              }}
              onClick={this.handleInviteFriendButton}
            >
              <ion-icon class="" name="ios-share-alt" />
            </button>
            {this.renderShareView()}
          </div>
          {/* <div style={{ display: "inline-block", textTransform: "uppercase" }}>
            <button
              className="btn btn_primary btn_skip"
              style={{
                textTransform: "uppercase",
                fontFamily: "DIN Pro Light"
              }}
              onClick={e => this.props.seeAnswers()}
            >
              See Answers
            </button>
          </div> */}
          {/* <div style={{ display: "inline-block", textTransform: "uppercase" }}>
            <Link to={"/"}>
              <button
                className="btn btn_primary btn_skip "
                style={{
                  textTransform: "uppercase",
                  fontFamily: "DIN Pro Light"
                }}
              >
                More Giveaways
              </button>
            </Link>
          </div> */}
        </div>
      </div>
    );
  }

  renderShareView() {
    if (this.state.showSharingView) {
      return (
        <SharingInviteView
          handlerInviteFriend={this.handlerInviteFriend}
          username={this.props.user.username}
        />
      );
    }
  }

  renderThanks() {
    if (this.props.list.give_away) {
      return (
        <label
          className="name "
          style={{
            fontFamily: "DIN Pro Light",
            fontWeight: "unset",
            textTransform: "capitalize",
            fontSize: "19px"
          }}
        >
          All Done! Thanks!
          <br />
          <span style={{ textTransform: "none" }}>
            Remember, the more friends you have, the more likely you are to win!
          </span>
        </label>
      );
    }
    return (
      <label
        className="name"
        style={{
          fontFamily: "DIN Pro Light",
          fontWeight: "unset",
          textTransform: "capitalize",
          fontSize: "19px"
        }}
      >
        All Done! Thanks!
      </label>
    );
  }

  renderInviteGiveaway() {
    return (
      <div
        className="page_top_nav profilePage list center"
        style={{ height: "calc(100% - 60px - 130px)" }}
      >
        <div
          style={
            {
              // top: "50%",
              // left: "50%",
              // transform: "translate(-50%, -50%)",
              // position: "absolute",
              // width: "100%"
            }
          }
        >
          <div className="">
            <div style={{ fontFamily: "DIN Pro Light" }}>You're In!</div>
            <img
              src={YAYImg}
              alt=""
              style={{ width: "45%", maxWidth: "500px", marginTop: "10px" }}
            />
            <div
              style={{
                width: "80%",
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: "10px",
                maxWidth: "500px"
              }}
            >
              <label style={{ fontFamily: "DIN Pro Light" }}>
                Let's keep it going!
              </label>
              <div style={{ marginTop: "20px", fontFamily: "DIN Pro Bold" }}>
                ENTER TO WIN
              </div>
              {this.renderImage()}
              <div style={{ marginTop: "10px", fontFamily: "DIN Pro Bold" }}>
                {this.props.invite_giveaway.item}
              </div>
              <div style={{ marginTop: "10px", fontFamily: "DIN PRO Light" }}>
                Simply add at least 1 new friend and each of you will be entered
                to win! <br />
                More friends = more chances to win *
              </div>
            </div>
          </div>
        </div>
        <div className="fixed-bottom pb-3">
          <div>
            <button
              className="btn btn_primary btn_yaystack  btn_next "
              onClick={this.handleInviteFriendButton}
              style={{ width: "50%", marginBottom: "0px" }}
            >
              LET'S GO
            </button>
            {this.renderShareView()}
          </div>

          <div
            style={{
              display: "inline-block",
              textTransform: "uppercase",
              marginBottom: "0px"
            }}
          >
            <Link to={"/"}>
              <button
                className="btn btn_primary btn_skip "
                style={{
                  textTransform: "uppercase",
                  fontFamily: "DIN Pro Bold",
                  backgroundColor: "transparent",
                  color: "#ff5116",
                  fontFamily: "DIN PRO Light",
                  marginBottom: "0px"
                }}
              >
                See More Giveaways
              </button>
            </Link>
          </div>
          <div style={{ fontFamily: "DIN PRO Light", fontSize: "12px" }}>
            * Each new friend = 1 additional entry
          </div>
        </div>
      </div>
    );
  }

  renderImage() {
    if (this.props.invite_giveaway.type === "image") {
      return (
        <div
          style={{
            width: "100%",
            // border: "solid 1px black",
            borderRadius: "10px",
            paddingTop: "50%",
            position: "relative",
            overflow: "hidden"
          }}
        >
          <img
            src={this.props.invite_giveaway.image_url_original}
            alt=""
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              top: "0px",
              left: "0px",
              objectFit: "contain"
            }}
          />
        </div>
      );
    }
  }

  handleInviteFriendButton = event => {
    event.preventDefault();
    const showSharingView = !this.state.showSharingView;
    this.setState({ showSharingView });
  };

  handlerInviteFriend = e => {
    const showSharingView = !this.state.showSharingView;
    this.setState({ showSharingView });
  };
}

export default ListFinished;



// WEBPACK FOOTER //
// ./src/components/list/interface/list_finished.jsx